/* eslint-disable */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */

export const createReducer = (initialState, handlers) => (
    state = initialState,
    action
) => (handlers[action.type] ? handlers[action.type](state, action) : state)
/* eslint-enable */

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const createAsyncAction = type => ({
  REQUEST: `${type}.REQUEST`,
  SUCCESS: `${type}.SUCCESS`,
  FAILURE: `${type}.FAILURE`,
})
